/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description Accepts a source of truth string
 * @param data raw source of truth is sent for identifying the acronym.
 * @returns Provides the acronym based on source of truth
 */

export const acronymResolver = (source) => {
  const sourceOfTruthAcronym = {
    'toast': '[T]',
    'manual': '[M]',
    'seven_shifts': '[7S]'
  }

  return sourceOfTruthAcronym[source] || ''
}
